import { render } from "./toggleSwitch.vue?vue&type=template&id=40490781&scoped=true&ts=true"
import script from "./toggleSwitch.vue?vue&type=script&lang=ts"
export * from "./toggleSwitch.vue?vue&type=script&lang=ts"

import "./toggleSwitch.vue?vue&type=style&index=0&id=40490781&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40490781"]])

export default __exports__